import { useState, useRef } from "react";
import send from "../icons/send.png";
import mic from "../icons/voicePrompt.png";

import { API_BASE1 } from "../config"; // adjust path if file is deeper
import axios from "axios"; // if you're using axios

export default function ChatInput({ placeholder, onSend }) {
  const [inputText, setInputText] = useState("");
  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      padding: '8px 12px',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
      fontFamily: 'Arial, sans-serif',
    },
    input: {
      flex: 1,
      border: 'none',
      outline: 'none',
      fontSize: '14px',
      padding: '8px',
      fontFamily: 'inherit',
    },
    icon: {
      width: '20px',
      height: '20px',
      marginLeft: '10px',
      cursor: 'pointer',
    },
  };

  const getSupportedMimeType = () => {
    const candidates = [
      'audio/webm;codecs=opus',
      'audio/ogg;codecs=opus',
      'audio/webm',
      'audio/ogg',
    ];
    for (const t of candidates) {
      try { if (MediaRecorder.isTypeSupported(t)) return t; } catch { }
    }
    return '';
  };

  const handleSend = () => {
    if (inputText.trim() !== "") {
      onSend(inputText);
      setInputText("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  const handleMicClick = async () => {
    if (!isRecording) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const mimeType = getSupportedMimeType();
        const mediaRecorder = new MediaRecorder(stream, mimeType ? { mimeType } : {});
        mediaRecorderRef.current = mediaRecorder;
        audioChunksRef.current = [];

        mediaRecorder.ondataavailable = (event) => {
          if (event.data && event.data.size > 0) {
            audioChunksRef.current.push(event.data);
          }
        };

        mediaRecorder.onstop = async () => {
          try {
            const ext = /ogg/.test(mimeType) ? 'ogg' : 'webm';
            const audioBlob = new Blob(audioChunksRef.current, { type: mimeType || 'audio/webm' });

            // Tiny-blob guard to avoid empty submissions
            if (audioBlob.size < 2000) {
              alert('No speech detected. Try again.');
              return;
            }

            const formData = new FormData();
            formData.append('audio', audioBlob, `recording.${ext}`);

            const res = await fetch(`${API_BASE1}/api/whisper/transcribe`, {
              method: 'POST',
              body: formData
            });

            // surface useful error text if server returns 500 with detail
            if (!res.ok) {
              const maybeJson = await res.json().catch(() => null);
              const detail = maybeJson?.detail || maybeJson?.error || `HTTP ${res.status}`;
              console.error('Whisper server error:', detail);
              alert('Whisper transcription failed');
              return;
            }

            const data = await res.json();
            if (data?.transcript) {
              onSend(data.transcript); // unified response shape
            } else {
              alert('No text detected from audio');
            }
          } catch (err) {
            console.error('Error sending audio to Whisper:', err);
            alert("Whisper transcription failed");
          } finally {
            // Stop tracks after we’re done
            try { stream.getTracks().forEach(t => t.stop()); } catch { }
          }
        };

        mediaRecorder.start();
        setIsRecording(true);

        // Optional: stop after 10 seconds max
        setTimeout(() => {
          if (mediaRecorder.state === 'recording') {
            mediaRecorder.stop();
            setIsRecording(false);
          }
        }, 10000);
      } catch (err) {
        console.error('Microphone access error:', err);
        alert("Microphone access denied or not supported.");
      }
    } else {
      try {
        mediaRecorderRef.current?.stop();
      } catch { }
      setIsRecording(false);
    }
  };


  return (
    <div style={styles.container}>
      <input
        type="text"
        placeholder={placeholder}
        style={styles.input}
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button
        onClick={handleSend}
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
      >
        <img src={send} alt="Send" style={styles.icon} />
      </button>
      <button
        onClick={handleMicClick}
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
      >
        <img
          src={mic}
          alt="Mic"
          style={{
            ...styles.icon,
            filter: isRecording ? "drop-shadow(0 0 5px red)" : "none"
          }}
        />
      </button>
    </div>
  );
}

/*
import { useState } from "react";
import send from "../icons/send.png";

export default function ChatInput({ placeholder, onSend }) {
  const [inputText, setInputText] = useState("");

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      padding: '8px 12px',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
      fontFamily: 'Arial, sans-serif',
    },
    input: {
      flex: 1,
      border: 'none',
      outline: 'none',
      fontSize: '14px',
      padding: '8px',
      fontFamily: 'inherit',
    },
    icon: {
      width: '20px',
      height: '20px',
      marginLeft: '10px',
      cursor: 'pointer',
    },
  };

  const handleSend = () => {
    if (inputText.trim() !== "") {
      onSend(inputText);
      setInputText("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  return (
    <div style={styles.container}>
      <input
        type="text"
        placeholder={placeholder}
        style={styles.input}
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button
        onClick={handleSend}
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
      >
        <img src={send} alt="Send" style={styles.icon} />
      </button>
    </div>
  );
}
*/


/*
import send from "../icons/send.png"

export default function ChatInput({ placeholder }) {
    const styles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            padding: '8px 12px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
            fontFamily: 'Arial, sans-serif',
        },
        input: {
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: '14px',
            padding: '8px',
            fontFamily: 'inherit',
        },
        icon: {
            width: '20px',
            height: '20px',
            marginLeft: '10px',
            cursor: 'pointer',
        },
    };

    return (
        <div style={styles.container}>
            <input type="text" placeholder={placeholder} style={styles.input} />
            <button style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}>
                <img src={send} alt="Send" style={styles.icon} />
            </button>
        </div>
    );
}
*/